import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coldfusion-dev',
  templateUrl: './coldfusion-dev.component.html',
  styleUrls: ['./coldfusion-dev.component.css']
})
export class ColdfusionDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/coldfusion-dev/coldfusion-dev.component.ts